jQuery(document).ready(function(){



    if (window.matchMedia("(min-width: 991px)").matches) {
        // HEADER STICKY
        var heightofHeader = jQuery('header').height();
        if (jQuery(window).scrollTop() >= heightofHeader) {
            jQuery("body").addClass('headersticky');
        }
        jQuery( window ).scroll(function() {
            if (jQuery(window).scrollTop() >= heightofHeader) {
                jQuery("body").addClass('headersticky');
            }
            if (jQuery(window).scrollTop() <= heightofHeader) {
                jQuery("body").removeClass('headersticky');
            }
        });
    }

    jQuery('.homepagetemplate_intro-carrousel').slick({
        arrows: false,
        dots: false,
        autoplay: true,
        infinite: true,
        autoplaySpeed: 4000,
        speed: 500,
        pauseOnHover: false,
        draggable: false
    });

    var counterSlide = 1;
    var counterSlideMax = jQuery('.homepagetemplate_intro-carrousel--counter .two').html();
    console.log(counterSlideMax);

    var t = setInterval(function(){ // run the following function

        if (counterSlide != counterSlideMax) {
            counterSlide++;
        }
        else {
            counterSlide = 1;
        }
        jQuery('.homepagetemplate_intro-carrousel--counter .one').html(counterSlide);
    
    },4500); // every 5000 milliseconds = 5 seconds

    jQuery('.homepagetemplate_intro-carrousel').prepend(jQuery('.o-home-pagination__circle'))

    jQuery('.homepagetemplate_use-carrousel--first---item-content').css('display', 'none');

    jQuery('.homepagetemplate_use-carrousel--two').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 800,
        dots: true,
        adaptiveHeight: true,
        vertical: true,
        pauseOnHover: true,
        focusOnSelect: true,
        asNavFor: '.homepagetemplate_use-carrousel--first',
        responsive: [
          {
            breakpoint: 992,
            settings: {
                autoplay: false,
            }
          }
        ]
    });
    jQuery('.homepagetemplate_use-carrousel--first').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 800,
        vertical: true,
        pauseOnHover: true,
        asNavFor: '.homepagetemplate_use-carrousel--two',
        dots: false,
        adaptiveHeight: true,
        focusOnSelect: true,
        responsive: [
          {
            breakpoint: 992,
            settings: {
                autoplay: false,
            }
          }
        ]
    });

    jQuery('.homepagetemplate_realisations h2').after(jQuery('.homepagetemplate_realisations #gallery > a.btn-primary'))

    Fancybox.bind('[data-fancybox="gallery-a"]', {
        // Custom options for the second gallery
        Carousel : {
          infinite: false
        }
      }); 

    jQuery('.homepagetemplate_animateurs-carrousel').slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 3,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    });

    // HEADER ANCRE
    var productsPosition = jQuery('#products').offset().top;
    var productsPositionClick = productsPosition - 220;
    var productsPositionFinal = productsPosition - 400;
    var avantagesPosition = jQuery('#avantages').offset().top;
    var avantagesPositionClick = avantagesPosition - 220;
    var avantagesPositionFinal = avantagesPosition - 400;
    var conceptPosition = jQuery('#concept').offset().top;
    var conceptPositionClick = conceptPosition - 220;
    var conceptPositionFinal = conceptPosition - 400;
    var labelsPosition = jQuery('#labels').offset().top;
    var labelsPositionFinal = labelsPosition - 400;
    var videoPosition = jQuery('#video').offset().top;
    var videoPositionFinal = videoPosition - 400;
    var realisationsPosition = jQuery('#realisations').offset().top;
    var realisationsPositionFinal = realisationsPosition - 400;
    
    
    jQuery( ".productsMenu" ).on( "click", function() {
        event.preventDefault();
        window.scrollTo({
            top: productsPositionClick,
            behavior: 'smooth'
        });
    } );
    jQuery( ".conceptMenu" ).on( "click", function() {
        event.preventDefault();
        window.scrollTo({
            top: conceptPositionClick,
            behavior: 'smooth'
        });
    } );
    jQuery( ".avantageMenu" ).on( "click", function() {
        event.preventDefault();
        window.scrollTo({
            top: avantagesPositionClick,
            behavior: 'smooth'
        });
    } );

    jQuery( window ).on( "scroll", function() {
        var documentPosition = jQuery(document).scrollTop();
        if (documentPosition < productsPositionFinal) {
            jQuery('#main-menu > li').removeClass('activeMenu');
        }
        if (documentPosition >= productsPositionFinal && documentPosition < labelsPositionFinal) {
            jQuery('#main-menu > li.productsMenu').addClass('activeMenu');
        }
        if (documentPosition >= labelsPositionFinal) {
            jQuery('#main-menu > li').removeClass('activeMenu');
        }
        if (documentPosition >= conceptPositionFinal && documentPosition < videoPositionFinal) {
            jQuery('#main-menu > li.conceptMenu').addClass('activeMenu');
        }
        if (documentPosition >= videoPositionFinal) {
            jQuery('#main-menu > li').removeClass('activeMenu');
        }
        if (documentPosition >= avantagesPositionFinal && documentPosition < realisationsPositionFinal) {
            jQuery('#main-menu > li.avantageMenu').addClass('activeMenu');
        }
        if (documentPosition >= realisationsPositionFinal) {
            jQuery('#main-menu > li').removeClass('activeMenu');
        }
    } );
    
    //SMOOTH SCROLLING
    jQuery(document).on('click', '.homepagetemplate_scrollup', function (event) {
        event.preventDefault();

        jQuery('html, body').animate({
            scrollTop: 0
        }, 500);
    });

}); // end jQuery(document).ready()

document.querySelectorAll('a[href="#homepagetemplate_form"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();

        const target = document.getElementById('homepagetemplate_form');
        const headerHeight = 78;
        const offsetTop = target.getBoundingClientRect().top + window.scrollY - headerHeight;

        window.scrollTo({ top: offsetTop, behavior: 'smooth' });

        setTimeout(() => {
            const correctedOffset = target.getBoundingClientRect().top + window.scrollY - headerHeight;
            window.scrollTo({ top: correctedOffset, behavior: 'smooth' });
        }, 300);
    });
});

